import { ApiResponse, TicketManagerRootCauseGroup, TicketManagerRootCauseReason } from '@vision/ui/interfaces';

export interface TicketManagerRootCauseReasonResponseDto {
  id: string;
  key?: string;
  name: string;
}

export interface TicketManagerRootCauseGroupResponseDto {
  id: string;
  name: string;
  project_id: string;
  reasons?: TicketManagerRootCauseReasonResponseDto[];
}

export function normalizeTicketManagerRootCauseReason(
  dto: TicketManagerRootCauseReasonResponseDto,
): TicketManagerRootCauseReason {
  return {
    id: dto.id,
    name: dto.name,
  };
}

export function normalizeTicketManagerRootCauseGroup(
  dto: TicketManagerRootCauseGroupResponseDto,
): TicketManagerRootCauseGroup {
  return {
    id: dto.id,
    name: dto.name,
    projectId: dto.project_id,
    reasons: Array.isArray(dto.reasons)
      ? dto.reasons.map((reason) => normalizeTicketManagerRootCauseReason(reason))
      : [],
  };
}

export function normalizeTicketManagerRootCauseGroupsResponse(
  response: ApiResponse<TicketManagerRootCauseGroupResponseDto[]>,
): ApiResponse<TicketManagerRootCauseGroup[]> {
  return {
    ...response,
    data: response.data.map(normalizeTicketManagerRootCauseGroup),
  };
}

export function normalizeTicketManagerRootCausesResponse(
  response: ApiResponse<TicketManagerRootCauseReasonResponseDto[]>,
): ApiResponse<TicketManagerRootCauseReason[]> {
  return {
    ...response,
    data: response.data.map(normalizeTicketManagerRootCauseReason),
  };
}

export function normalizeTicketManagerRootCauseGroupResponse(
  response: ApiResponse<TicketManagerRootCauseGroupResponseDto>,
): ApiResponse<TicketManagerRootCauseGroup> {
  return {
    ...response,
    data: normalizeTicketManagerRootCauseGroup(response.data),
  };
}

export function normalizeTicketManagerRootCauseResponse(
  response: ApiResponse<TicketManagerRootCauseReasonResponseDto>,
): ApiResponse<TicketManagerRootCauseReason> {
  return {
    ...response,
    data: normalizeTicketManagerRootCauseReason(response.data),
  };
}
